"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '@/store';
import router from '@/router'

import { Message, MessageBox } from 'element-ui'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
};

const _axios = axios.create(config);

// 配置请求拦截器
_axios.interceptors.request.use(
  function (config) {
    //为所有请求头添加token
    if (store.state.user.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = store.state.user.token
    }

    return config;
  },
  function (error) {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
  }
);

// 添加返回拦截器
_axios.interceptors.response.use(
  function (response) {
    const res = response.data
    if (response.status !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

       // 处理强制退出
      disposeResponse(response)

      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response
    }
  },
  function (error) {
    // Do something with response error
    // 处理401，403
    disposeResponse(error.response)
    return Promise.reject(new Error('Error'))
  }
);

/**
 * 当返回401，403时，弹出强制登出对话框,弹出没有权限提示
 */
function disposeResponse(response) {
  if (response.status === 403 || ((response.data && response.data.status) === 403)) {
    MessageBox.confirm(
      '你已被登出，可以取消继续留在该页面，或者重新登录',
      '确定登出',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      store.commit("set", ["user.info", {}]);
      store.commit("save", ["user.token", ""]);
      
      // 跳转到登陆页
      router.push("/login");
      // store.dispatch('LogOut').then(() => {
      //   //location.reload() // 为了重新实例化vue-router对象 避免bug
      //   //重新登陆弹框
      //   console.log(store)
      //   location.reload()
      // })
    })
  }else if(response.status === 401 || ((response.data && response.data.status) === 401)){
    MessageBox.alert("你没有当前操作的权限!","提示",{type: 'warning'});
  }
}

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
